// Decidir si ofrecer "instalar MiPAE" desde el navegador.
//
// Vive aparte y es puro porque la heuristica de iOS es engañosa: dentro de la
// app NATIVA el WebView de Apple dice "iPhone" y "WebKit" igual que Safari, y
// no esta en display-mode standalone ni tiene navigator.standalone. O sea,
// cumple TODAS las señales de "Safari en un iPhone sin instalar" siendo
// justamente lo contrario: la app ya instalada. Sin la guarda de plataforma,
// la app nativa abria pidiendole al usuario que la instalara desde una barra
// de Safari que ahi no existe (le paso a una tester el 2026-09-03).
//
// Regla: en nativo NO se ofrece instalar nada, nunca. Ya esta instalada.

export function debeOfrecerInstalacion({ nativo, displayModeStandalone, dismissed }) {
  if (nativo) return false;
  if (displayModeStandalone) return false;
  if (dismissed) return false;
  return true;
}

export function debeMostrarInstruccionesSafari({
  nativo,
  userAgent,
  displayModeStandalone,
  navigatorStandalone,
  dismissed,
}) {
  if (!debeOfrecerInstalacion({ nativo, displayModeStandalone, dismissed })) return false;
  // navigator.standalone solo existe en iOS y marca la PWA ya agregada a la
  // pantalla de inicio: si es true, tampoco hay nada que instalar.
  if (navigatorStandalone === true) return false;
  const ua = userAgent || '';
  const esIOS = /iPhone|iPad|iPod/.test(ua);
  // Chrome y Firefox en iOS corren sobre WebKit pero no tienen el flujo de
  // "Agregar a pantalla de inicio", asi que las instrucciones no les sirven.
  const esSafari = /WebKit/.test(ua) && !/CriOS/.test(ua) && !/FxiOS/.test(ua);
  return esIOS && esSafari;
}
